import { Plugins, Context } from '@leverege/plugin';
const factory = Plugins.createFactory('DataViewer', Plugins.LOOKUP);
class DataViewers {
  constructor(context) {
    this.context = typeof context === 'string' ? {
      type: context
    } : context || {};
    this.version = -1;
    this.dataViewers = [];
  }

  /**
   * Finds the DataViewer by its type.
   * @param {String|Object} objOrType The type of the dataViewer or object containing { type } to return the DataViewer for
   * @returns DataViewer 
   */
  static get(objOrType) {
    return objOrType == null ? null : factory.get(objOrType);
  }

  /**
   * Returns true if the DataViewers object holds DataViewers of the specified type
   * @param {string} type The type of DataViewers to compare against
   * @returns boolean
   */
  areOfType(type) {
    if (Array.isArray(this.context.type)) {
      return this.context.type.includes(type);
    }
    return this.context.type === type;
  }
  getAll(context) {
    const cVersion = Plugins.getVersion('DataViewer');
    if (this.version !== cVersion || this.userContext !== context) {
      this.version = cVersion;
      this.userContext = context;
      this.dataViewers = Plugins.get('DataViewer', Context.createMatch({
        ...context,
        ...this.context
      }));
    }
    return this.dataViewers;
  }

  /**
   * Returns all DataViewers in this object that can be used in the specified location
   * @param {String} use the location to filter the DataViewers for. Examples include 'main', 'aux', 'card', 'hidden'
   * @returns an Array of avaliable DataViewers
   */
  getFor(use, strict = false, context = {}) {
    return this.getAll(context).filter(dv => {
      return match(dv.location, use, strict);
    });
  }
  filterOutUsed(arr, used) {
    return arr;
  }

  /**
   * This is equivalent to DataViewers.get( objOrType )
   * @param {String|Object} objOrType 
   * @returns DataViewer or null
   */
  getByType(objOrType) {
    return DataViewers.get(objOrType);
  }
}
function contains(arr, use) {
  return Array.isArray(arr) && arr.includes(use);
}
function match(location, use, strict = false) {
  if (use == null || location === 'any' && !strict) {
    return true;
  }
  if (use === true || use === 'aux') {
    return location === 'aux' || location === 'any' && !strict || contains(location, 'aux');
  }
  if (use === false || use === 'main' || use === 'card') {
    return location == null || location === use || location === 'any' && !strict || contains(location, use);
  }
  return location === use || location === 'any' && !strict || contains(location, use);
}

// function relationshipPath( relationship ) {
//   return relationship?.path || 'unknownRelationship'
// }

// function create( TYPE, pathFunc = relationshipPath ) {

//   /**
//    * Gets the DataViewers for the condition object and use
//    * @param {Object} cndObj Normally the relationship object
//    * @param {*} useName 'main', 'aux', 'card', 'hidden', etc
//    * @returns the view of the dataviewers
//    */
//   function get( cndObj, useName ) {
//     const path = pathFunc( cndObj )
//     const use = typeof useName === 'string' ? useName : 
//       ( useName === null ? 'all' : ( useName === true ? 'aux' : 'main' ) )
//     const name = `${path}:${use}` 
//     let dv = Plugins.getView( TYPE, name )
//     if ( dv === null ) {
//       dv = Plugins.createView( TYPE, {
//         name,
//         filter : ( item ) => {
//           return match( item.location, use ) && item.handles( cndObj )
//         }
//       } )
//     }
//     return dv.get()
//   }

//   function filterOutUsed( viewers, used ) {
//     return viewers.filter( ( dv ) => { 
//       if ( dv.type == null ) {
//         return true
//       }
//       for ( let n = 0; n < used.length; n++ ) {
//         if ( dv.type === used[n] || dv.type === used[n]?.type ) {
//           return false
//         }
//       }
//       return true
//     } )
//   }

//   function getByType( viewers, type ) {
//     if ( !Array.isArray( viewers ) ) {
//       type = viewers // eslint-disable-line no-param-reassign
//       viewers = Plugins.get( TYPE ) // eslint-disable-line no-param-reassign
//     }

//     if ( viewers == null ) {
//       return null
//     }
//     const t = typeof type === 'object' && type != null ? type.type : type
//     return viewers.find( dv => dv.type === t ) || null
//   }

//   return {
//     type : TYPE, get, getByType, filterOutUsed
//   }
// }

const GroupDataViewers = new DataViewers('GroupDataViewer');
const ItemInfoDataViewers = new DataViewers('ItemInfoDataViewer');
export default DataViewers;
export { ItemInfoDataViewers, GroupDataViewers };